export const typography = {
  family: {
    primary: 'Manrope',
    medium: 'Manrope Medium',
    bold: 'Manrope Bold'
  },
  weight: {
    xsm: '400',
    sm: '500',
    md: '600',
    lg: '700',
    xl: '800'
  },
  sizes: {
    '3xs': '10px',
    '2xs': '12px',
    xs: '14px',
    sm: '16px',
    md: '18px',
    xm: '20px',
    '2md': '22px',
    '3md': '26px',
    lg: '30px',
    xl: '36px',
    '2xl': '40px',
    '3xl': '60px'
  },
  lineHeight: {
    sm: '100%',
    md: '124%',
    lg: '140%'
  },
  decoration: {
    none: 'none',
    underline: 'underline',
    uppercase: 'uppercase',
    lineThrough: 'line-through'
  },
  align: {
    left: 'left',
    center: 'center',
    right: 'right'
  }
} as const
